import { useEffect, useRef, useState } from "react";
import "./VideoLandScap.scss";
import { WistiaVideo } from "../../../components/index.js";

const VideoLandScap = ({ videoId }) => {
   
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="video_landscap p_b"> 
      {videoId && (
        <WistiaVideo
          vId={videoId}
          w={30}
          h={10}
        />
      )}
    </section>
  );
};
export default VideoLandScap;
